/*
 * @author: pengjun
 * @date: 2024-12-13
 * @lastEditors: pengjun
 * @lastEditTime: 2025-09-05
 * @description:
 */
import React from 'react';
import Copyright from '@/components/Copyright';
import './index.scss'

function Footer() {
  return (
    <div className='footer-container'>
      <Copyright />
    </div>
  );
}

export default Footer;
